export default __webpack_public_path__ + "media/images/borders/brown-border-light-9e8755fc8ef576e98c9c549d64b6fb09.svg";